import React, { useState, useEffect, useRef } from 'react'

export const UnitedAnesthesiaHeader = () => {
	const [activeDropdown, setActiveDropdown] = useState(null)
	const menuRef = useRef(null)

	const handleDropdownClick = (index) => {
		// Toggle dropdown - nếu click vào item đang active thì close nó
		setActiveDropdown(activeDropdown === index ? null : index)
	}

	useEffect(() => {
		const handleClickOutside = (event) => {
			// Kiểm tra nếu click target không nằm trong menu thì đóng dropdown
			if (menuRef.current && !menuRef.current.contains(event.target)) {
				setActiveDropdown(null)
			}
		}

		// Thêm event listener
		document.addEventListener('mousedown', handleClickOutside)

		// Cleanup function
		return () => {
			document.removeEventListener('mousedown', handleClickOutside)
		}
	}, [])

	return (
		<>
			{/* <Helmet> */}
			<meta http-equiv="Content-Type" content="text/html; charset=UTF-8" />
			<meta name="viewport" content="width=device-width, initial-scale=1.0" />
			<meta http-equiv="X-UA-Compatible" content="IE=edge, IE=11, IE=10" />
			<title>Search Jobs | United Anesthesia</title>
			<meta name="robots" content="max-image-preview:large" />
			<meta
				name="description"
				content="Specializing in Certified Registered Nurse Anesthetist (CRNA) and Anesthesiologist Placement as well as Supplemental Staffing / Recruitment for Facilities."
			/>
			<link rel="canonical" href="https://www.unitedanesthesia.com/" />
			<link rel="shortcut icon" href="https://www.unitedanesthesia.com/favicon.ico" />
			<link rel="apple-touch-icon" sizes="180x180" href="https://static.animusrex.com/unitedanesthesia/images/favicons/apple-touch-icon.png" />
			<link rel="icon" type="image/png" sizes="32x32" href="https://static.animusrex.com/unitedanesthesia/images/favicons/favicon-32x32.png" />
			<link rel="icon" type="image/png" sizes="16x16" href="https://static.animusrex.com/unitedanesthesia/images/favicons/favicon-16x16.png" />
			<link rel="manifest" href="https://static.animusrex.com/unitedanesthesia/images/favicons/site.webmanifest" />
			<link rel="mask-icon" href="https://static.animusrex.com/unitedanesthesia/images/favicons/safari-pinned-tab.svg" color="#5bbad5" />
			<meta name="msapplication-TileColor" content="#ffffff" />
			<meta name="msapplication-config" content="https://static.animusrex.com/unitedanesthesia/images/favicons/browserconfig.xml" />
			<meta name="theme-color" content="#ffffff" />
			<meta property="og:locale" content="en_US" />
			<meta property="og:type" content="website" />
			<meta property="og:title" content="United Anesthesia - The science of anesthesia recruitment and placement - United Anesthesia" />
			<meta
				property="og:description"
				content="Specializing in Certified Registered Nurse Anesthetist (CRNA) and Anesthesiologist Placement as well as Supplemental Staffing / Recruitment for Facilities."
			/>
			<meta property="og:url" content="https://www.unitedanesthesia.com/" />
			<meta property="og:site_name" content="United Anesthesia" />
			<meta name="twitter:card" content="summary" />
			<meta
				name="twitter:description"
				content="Specializing in Certified Registered Nurse Anesthetist (CRNA) and Anesthesiologist Placement as well as Supplemental Staffing / Recruitment for Facilities."
			/>
			<meta name="twitter:title" content="United Anesthesia - The science of anesthesia recruitment and placement - United Anesthesia" />
			<meta name="twitter:site" content="@UnitedAnesthesi" />
			<meta name="twitter:creator" content="@UnitedAnesthesi" />
			<script type="application/ld+json" nonce="">
				{` {
        "@context": "http://schema.org",
        "@type": "WebSite",
        "@id": "#website",
        "url": "https://www.unitedanesthesia.com",
        "name": "United Anesthesia"
      }`}
			</script>
			<link rel="dns-prefetch" href="https://fonts.googleapis.com/" />
			<link rel="stylesheet" href="/assets/united-anesthesia/scripts/style.min.css" type="text/css" media="all" />
			<style type="text/css">
				{`
      .wp-block-button__link {
        color: #fff;
        background-color: #32373c;
        border-radius: 9999px;
        box-shadow: none;
        text-decoration: none;
        padding: calc(0.667em + 2px) calc(1.333em + 2px);
        font-size: 1.125em;
      }
      .wp-block-file__button {
        background: #32373c;
        color: #fff;
        text-decoration: none;
      }`}
			</style>
			<style type="text/css">
				{` :root {
        --wp--preset--aspect-ratio--square: 1;
        --wp--preset--aspect-ratio--4-3: 4/3;
        --wp--preset--aspect-ratio--3-4: 3/4;
        --wp--preset--aspect-ratio--3-2: 3/2;
        --wp--preset--aspect-ratio--2-3: 2/3;
        --wp--preset--aspect-ratio--16-9: 16/9;
        --wp--preset--aspect-ratio--9-16: 9/16;
        --wp--preset--color--black: #000000;
        --wp--preset--color--cyan-bluish-gray: #abb8c3;
        --wp--preset--color--white: #ffffff;
        --wp--preset--color--pale-pink: #f78da7;
        --wp--preset--color--vivid-red: #cf2e2e;
        --wp--preset--color--luminous-vivid-orange: #ff6900;
        --wp--preset--color--luminous-vivid-amber: #fcb900;
        --wp--preset--color--light-green-cyan: #7bdcb5;
        --wp--preset--color--vivid-green-cyan: #00d084;
        --wp--preset--color--pale-cyan-blue: #8ed1fc;
        --wp--preset--color--vivid-cyan-blue: #0693e3;
        --wp--preset--color--vivid-purple: #9b51e0;
        --wp--preset--gradient--vivid-cyan-blue-to-vivid-purple: linear-gradient(
          135deg,
          rgba(6, 147, 227, 1) 0%,
          rgb(155, 81, 224) 100%
        );
        --wp--preset--gradient--light-green-cyan-to-vivid-green-cyan: linear-gradient(
          135deg,
          rgb(122, 220, 180) 0%,
          rgb(0, 208, 130) 100%
        );
        --wp--preset--gradient--luminous-vivid-amber-to-luminous-vivid-orange: linear-gradient(
          135deg,
          rgba(252, 185, 0, 1) 0%,
          rgba(255, 105, 0, 1) 100%
        );
        --wp--preset--gradient--luminous-vivid-orange-to-vivid-red: linear-gradient(
          135deg,
          rgba(255, 105, 0, 1) 0%,
          rgb(207, 46, 46) 100%
        );
        --wp--preset--gradient--very-light-gray-to-cyan-bluish-gray: linear-gradient(
          135deg,
          rgb(238, 238, 238) 0%,
          rgb(169, 184, 195) 100%
        );
        --wp--preset--gradient--cool-to-warm-spectrum: linear-gradient(
          135deg,
          rgb(74, 234, 220) 0%,
          rgb(151, 120, 209) 20%,
          rgb(207, 42, 186) 40%,
          rgb(238, 44, 130) 60%,
          rgb(251, 105, 98) 80%,
          rgb(254, 248, 76) 100%
        );
        --wp--preset--gradient--blush-light-purple: linear-gradient(
          135deg,
          rgb(255, 206, 236) 0%,
          rgb(152, 150, 240) 100%
        );
        --wp--preset--gradient--blush-bordeaux: linear-gradient(
          135deg,
          rgb(254, 205, 165) 0%,
          rgb(254, 45, 45) 50%,
          rgb(107, 0, 62) 100%
        );
        --wp--preset--gradient--luminous-dusk: linear-gradient(
          135deg,
          rgb(255, 203, 112) 0%,
          rgb(199, 81, 192) 50%,
          rgb(65, 88, 208) 100%
        );
        --wp--preset--gradient--pale-ocean: linear-gradient(
          135deg,
          rgb(255, 245, 203) 0%,
          rgb(182, 227, 212) 50%,
          rgb(51, 167, 181) 100%
        );
        --wp--preset--gradient--electric-grass: linear-gradient(
          135deg,
          rgb(202, 248, 128) 0%,
          rgb(113, 206, 126) 100%
        );
        --wp--preset--gradient--midnight: linear-gradient(
          135deg,
          rgb(2, 3, 129) 0%,
          rgb(40, 116, 252) 100%
        );
        --wp--preset--font-size--small: 13px;
        --wp--preset--font-size--medium: 20px;
        --wp--preset--font-size--large: 36px;
        --wp--preset--font-size--x-large: 42px;
        --wp--preset--spacing--20: 0.44rem;
        --wp--preset--spacing--30: 0.67rem;
        --wp--preset--spacing--40: 1rem;
        --wp--preset--spacing--50: 1.5rem;
        --wp--preset--spacing--60: 2.25rem;
        --wp--preset--spacing--70: 3.38rem;
        --wp--preset--spacing--80: 5.06rem;
        --wp--preset--shadow--natural: 6px 6px 9px rgba(0, 0, 0, 0.2);
        --wp--preset--shadow--deep: 12px 12px 50px rgba(0, 0, 0, 0.4);
        --wp--preset--shadow--sharp: 6px 6px 0px rgba(0, 0, 0, 0.2);
        --wp--preset--shadow--outlined: 6px 6px 0px -3px rgba(255, 255, 255, 1),
          6px 6px rgba(0, 0, 0, 1);
        --wp--preset--shadow--crisp: 6px 6px 0px rgba(0, 0, 0, 1);
      }
      :where(.is-layout-flex) {
        gap: 0.5em;
      }
      :where(.is-layout-grid) {
        gap: 0.5em;
      }
      body .is-layout-flex {
        display: flex;
      }
      .is-layout-flex {
        flex-wrap: wrap;
        align-items: center;
      }
      .is-layout-flex > :is(*, div) {
        margin: 0;
      }
      body .is-layout-grid {
        display: grid;
      }
      .is-layout-grid > :is(*, div) {
        margin: 0;
      }
      :where(.wp-block-columns.is-layout-flex) {
        gap: 2em;
      }
      :where(.wp-block-columns.is-layout-grid) {
        gap: 2em;
      }
      :where(.wp-block-post-template.is-layout-flex) {
        gap: 1.25em;
      }
      :where(.wp-block-post-template.is-layout-grid) {
        gap: 1.25em;
      }
      .has-black-color {
        color: var(--wp--preset--color--black) !important;
      }
      .has-cyan-bluish-gray-color {
        color: var(--wp--preset--color--cyan-bluish-gray) !important;
      }
      .has-white-color {
        color: var(--wp--preset--color--white) !important;
      }
      .has-pale-pink-color {
        color: var(--wp--preset--color--pale-pink) !important;
      }
      .has-vivid-red-color {
        color: var(--wp--preset--color--vivid-red) !important;
      }
      .has-luminous-vivid-orange-color {
        color: var(--wp--preset--color--luminous-vivid-orange) !important;
      }
      .has-luminous-vivid-amber-color {
        color: var(--wp--preset--color--luminous-vivid-amber) !important;
      }
      .has-light-green-cyan-color {
        color: var(--wp--preset--color--light-green-cyan) !important;
      }
      .has-vivid-green-cyan-color {
        color: var(--wp--preset--color--vivid-green-cyan) !important;
      }
      .has-pale-cyan-blue-color {
        color: var(--wp--preset--color--pale-cyan-blue) !important;
      }
      .has-vivid-cyan-blue-color {
        color: var(--wp--preset--color--vivid-cyan-blue) !important;
      }
      .has-vivid-purple-color {
        color: var(--wp--preset--color--vivid-purple) !important;
      }
      .has-black-background-color {
        background-color: var(--wp--preset--color--black) !important;
      }
      .has-cyan-bluish-gray-background-color {
        background-color: var(--wp--preset--color--cyan-bluish-gray) !important;
      }
      .has-white-background-color {
        background-color: var(--wp--preset--color--white) !important;
      }
      .has-pale-pink-background-color {
        background-color: var(--wp--preset--color--pale-pink) !important;
      }
      .has-vivid-red-background-color {
        background-color: var(--wp--preset--color--vivid-red) !important;
      }
      .has-luminous-vivid-orange-background-color {
        background-color: var(
          --wp--preset--color--luminous-vivid-orange
        ) !important;
      }
      .has-luminous-vivid-amber-background-color {
        background-color: var(
          --wp--preset--color--luminous-vivid-amber
        ) !important;
      }
      .has-light-green-cyan-background-color {
        background-color: var(--wp--preset--color--light-green-cyan) !important;
      }
      .has-vivid-green-cyan-background-color {
        background-color: var(--wp--preset--color--vivid-green-cyan) !important;
      }
      .has-pale-cyan-blue-background-color {
        background-color: var(--wp--preset--color--pale-cyan-blue) !important;
      }
      .has-vivid-cyan-blue-background-color {
        background-color: var(--wp--preset--color--vivid-cyan-blue) !important;
      }
      .has-vivid-purple-background-color {
        background-color: var(--wp--preset--color--vivid-purple) !important;
      }
      .has-black-border-color {
        border-color: var(--wp--preset--color--black) !important;
      }
      .has-cyan-bluish-gray-border-color {
        border-color: var(--wp--preset--color--cyan-bluish-gray) !important;
      }
      .has-white-border-color {
        border-color: var(--wp--preset--color--white) !important;
      }
      .has-pale-pink-border-color {
        border-color: var(--wp--preset--color--pale-pink) !important;
      }
      .has-vivid-red-border-color {
        border-color: var(--wp--preset--color--vivid-red) !important;
      }
      .has-luminous-vivid-orange-border-color {
        border-color: var(
          --wp--preset--color--luminous-vivid-orange
        ) !important;
      }
      .has-luminous-vivid-amber-border-color {
        border-color: var(--wp--preset--color--luminous-vivid-amber) !important;
      }
      .has-light-green-cyan-border-color {
        border-color: var(--wp--preset--color--light-green-cyan) !important;
      }
      .has-vivid-green-cyan-border-color {
        border-color: var(--wp--preset--color--vivid-green-cyan) !important;
      }
      .has-pale-cyan-blue-border-color {
        border-color: var(--wp--preset--color--pale-cyan-blue) !important;
      }
      .has-vivid-cyan-blue-border-color {
        border-color: var(--wp--preset--color--vivid-cyan-blue) !important;
      }
      .has-vivid-purple-border-color {
        border-color: var(--wp--preset--color--vivid-purple) !important;
      }
      .has-vivid-cyan-blue-to-vivid-purple-gradient-background {
        background: var(
          --wp--preset--gradient--vivid-cyan-blue-to-vivid-purple
        ) !important;
      }
      .has-light-green-cyan-to-vivid-green-cyan-gradient-background {
        background: var(
          --wp--preset--gradient--light-green-cyan-to-vivid-green-cyan
        ) !important;
      }
      .has-luminous-vivid-amber-to-luminous-vivid-orange-gradient-background {
        background: var(
          --wp--preset--gradient--luminous-vivid-amber-to-luminous-vivid-orange
        ) !important;
      }
      .has-luminous-vivid-orange-to-vivid-red-gradient-background {
        background: var(
          --wp--preset--gradient--luminous-vivid-orange-to-vivid-red
        ) !important;
      }
      .has-very-light-gray-to-cyan-bluish-gray-gradient-background {
        background: var(
          --wp--preset--gradient--very-light-gray-to-cyan-bluish-gray
        ) !important;
      }
      .has-cool-to-warm-spectrum-gradient-background {
        background: var(
          --wp--preset--gradient--cool-to-warm-spectrum
        ) !important;
      }
      .has-blush-light-purple-gradient-background {
        background: var(--wp--preset--gradient--blush-light-purple) !important;
      }
      .has-blush-bordeaux-gradient-background {
        background: var(--wp--preset--gradient--blush-bordeaux) !important;
      }
      .has-luminous-dusk-gradient-background {
        background: var(--wp--preset--gradient--luminous-dusk) !important;
      }
      .has-pale-ocean-gradient-background {
        background: var(--wp--preset--gradient--pale-ocean) !important;
      }
      .has-electric-grass-gradient-background {
        background: var(--wp--preset--gradient--electric-grass) !important;
      }
      .has-midnight-gradient-background {
        background: var(--wp--preset--gradient--midnight) !important;
      }
      .has-small-font-size {
        font-size: var(--wp--preset--font-size--small) !important;
      }
      .has-medium-font-size {
        font-size: var(--wp--preset--font-size--medium) !important;
      }
      .has-large-font-size {
        font-size: var(--wp--preset--font-size--large) !important;
      }
      .has-x-large-font-size {
        font-size: var(--wp--preset--font-size--x-large) !important;
      }
      :where(.wp-block-post-template.is-layout-flex) {
        gap: 1.25em;
      }
      :where(.wp-block-post-template.is-layout-grid) {
        gap: 1.25em;
      }
      :where(.wp-block-columns.is-layout-flex) {
        gap: 2em;
      }
      :where(.wp-block-columns.is-layout-grid) {
        gap: 2em;
      }
      :root :where(.wp-block-pullquote) {
        font-size: 1.5em;
        line-height: 1.6;
      }`}
			</style>
			<link rel="stylesheet" href="/assets/united-anesthesia/scripts/styles.css" type="text/css" media="all" />
			<link rel="stylesheet" href="/assets/united-anesthesia/scripts/style.css" type="text/css" media="all" />
			<link rel="stylesheet" href="/assets/united-anesthesia/scripts/js_composer.min.css" type="text/css" media="all" />
			<link rel="stylesheet" href="/assets/united-anesthesia/scripts/css" type="text/css" media="all" />
			<link rel="stylesheet" href="/assets/united-anesthesia/scripts/bootstrap.css" type="text/css" media="all" />
			<link rel="stylesheet" href="/assets/united-anesthesia/scripts/icons.css" type="text/css" media="all" />
			<link rel="stylesheet" href="/assets/united-anesthesia/scripts/plugins.css" type="text/css" media="all" />
			<link rel="stylesheet" href="/assets/united-anesthesia/scripts/theme-438a73d941.css" type="text/css" media="all" />
			<style type="text/css">
				{`
      .btn--primary .btn__text,
      .btn--primary:visited .btn__text {
        color: #ffffff;
      }
      input[type].btn--primary,
      .pos-fixed.bar--transparent.bg--primary,
      .ebor-cart-count,
      .woocommerce #respond input#submit.alt.disabled,
      .woocommerce #respond input#submit.alt.disabled:hover,
      .woocommerce #respond input#submit.alt:disabled,
      .woocommerce #respond input#submit.alt:disabled:hover,
      .woocommerce #respond input#submit.alt:disabled[disabled],
      .woocommerce #respond input#submit.alt:disabled[disabled]:hover,
      .woocommerce a.button.alt.disabled,
      .woocommerce a.button.alt.disabled:hover,
      .woocommerce a.button.alt:disabled,
      .woocommerce a.button.alt:disabled:hover,
      .woocommerce a.button.alt:disabled[disabled],
      .woocommerce a.button.alt:disabled[disabled]:hover,
      .woocommerce button.button.alt.disabled,
      .woocommerce button.button.alt.disabled:hover,
      .woocommerce button.button.alt:disabled,
      .woocommerce button.button.alt:disabled:hover,
      .woocommerce button.button.alt:disabled[disabled],
      .woocommerce button.button.alt:disabled[disabled]:hover,
      .woocommerce input.button.alt.disabled,
      .woocommerce input.button.alt.disabled:hover,
      .woocommerce input.button.alt:disabled,
      .woocommerce input.button.alt:disabled:hover,
      .woocommerce input.button.alt:disabled[disabled],
      .woocommerce input.button.alt:disabled[disabled]:hover {
        background: #4a90e2;
      }
      .pos-fixed.bar--transparent.bg--secondary {
        background: #ffffff;
      }
      .pos-fixed.bar--transparent.bg--dark {
        background: #31639c;
      }
      .pos-fixed.bar--transparent.bg--primary-1 {
        background: #31639c;
      }
      .bg--white h1,
      .bg--white h2,
      .bg--white h3,
      .bg--white h4,
      .bg--white h5,
      .bg--white h6,
      .bg--white i,
      .mobile-header .cart-link {
        color: #31639c;
      }
      @media all and (max-width: 767px) {
        .bar.bg--dark.bar--mobile-sticky[data-scroll-class*="fixed"].pos-fixed,
        .bar.bg--dark.bar--mobile-sticky[data-scroll-class*="fixed"]
          + .bar.pos-fixed {
          background: #31639c;
        }
        .bar.bg--secondary.bar--mobile-sticky[data-scroll-class*="fixed"].pos-fixed,
        .bar.bg--secondary.bar--mobile-sticky[data-scroll-class*="fixed"]
          + .bar.pos-fixed {
          background: #ffffff;
        }
      }
      .thumbnails-slider .thumbnail-trigger.active img {
        border: 1px solid #4a90e2;
      }
      .menu-horizontal > li > a,
      .menu-horizontal > li > span,
      .menu-horizontal > li > .modal-instance > .modal-trigger {
        font-size: 1em;
      }
      .woocommerce #respond input#submit.alt,
      .woocommerce a.button.alt,
      .woocommerce button.button.alt,
      .woocommerce input.button.alt,
      .woocommerce #respond input#submit,
      .woocommerce a.button,
      .woocommerce button.button,
      .woocommerce input.button {
        background: #4a90e2;
        color: #fff;
        transition: 0.1s linear;
      }
      .woocommerce #respond input#submit.alt:hover,
      .woocommerce a.button.alt:hover,
      .woocommerce button.button.alt:hover,
      .woocommerce input.button.alt:hover,
      .woocommerce #respond input#submit:hover,
      .woocommerce a.button:hover,
      .woocommerce button.button:hover,
      .woocommerce input.button:hover {
        color: #fff;
        opacity: 0.9;
        background: #4a90e2;
        transform: translate3d(0, -2px, 0);
        -webkit-transform: translate3d(0, -2px, 0);
      }
      .col-md-11.col-sm-12.text-right.text-left-xs.text-left-sm {
        margin-top: 36px;
      }`}
			</style>
			<link rel="stylesheet" href="/assets/united-anesthesia/scripts/iconsmind.css" type="text/css" media="all" />
			<script src="/assets/united-anesthesia/scripts/jquery.min.js"></script>
			<script src="/assets/united-anesthesia/scripts/jquery-migrate-3.4.1.js"></script>
			<script type="text/javascript" src="/assets/united-anesthesia/scripts/rbtools.min.js" async=""></script>
			<script type="text/javascript" src="/assets/united-anesthesia/scripts/rs6.min.js" async=""></script>
			<style type="text/css" id="custom-background-css">
				{`  body.custom-background {
        background-image: url("/images/background-pattern-1.jpg");
        background-position: left top;
        background-size: auto;
        background-repeat: repeat;
        background-attachment: scroll;
      } `}
			</style>
			<script>
				{`  function setREVStartSize(e) {
        window.RSIW =
          window.RSIW === undefined ? window.innerWidth : window.RSIW;
        window.RSIH =
          window.RSIH === undefined ? window.innerHeight : window.RSIH;
        try {
          var pw = document.getElementById(e.c).parentNode.offsetWidth,
            newh;
          pw =
            pw === 0 ||
            isNaN(pw) ||
            e.l == "fullwidth" ||
            e.layout == "fullwidth"
              ? window.RSIW
              : pw;
          e.tabw = e.tabw === undefined ? 0 : parseInt(e.tabw);
          e.thumbw = e.thumbw === undefined ? 0 : parseInt(e.thumbw);
          e.tabh = e.tabh === undefined ? 0 : parseInt(e.tabh);
          e.thumbh = e.thumbh === undefined ? 0 : parseInt(e.thumbh);
          e.tabhide = e.tabhide === undefined ? 0 : parseInt(e.tabhide);
          e.thumbhide = e.thumbhide === undefined ? 0 : parseInt(e.thumbhide);
          e.mh =
            e.mh === undefined || e.mh == "" || e.mh === "auto"
              ? 0
              : parseInt(e.mh, 0);
          if (e.layout === "fullscreen" || e.l === "fullscreen")
            newh = Math.max(e.mh, window.RSIH);
          else {
            e.gw = Array.isArray(e.gw) ? e.gw : [e.gw];
            for (var i in e.rl)
              if (e.gw[i] === undefined || e.gw[i] === 0) e.gw[i] = e.gw[i - 1];
            e.gh =
              e.el === undefined ||
              e.el === "" ||
              (Array.isArray(e.el) && e.el.length == 0)
                ? e.gh
                : e.el;
            e.gh = Array.isArray(e.gh) ? e.gh : [e.gh];
            for (var i in e.rl)
              if (e.gh[i] === undefined || e.gh[i] === 0) e.gh[i] = e.gh[i - 1];
            var nl = new Array(e.rl.length),
              ix = 0,
              sl;
            e.tabw = e.tabhide >= pw ? 0 : e.tabw;
            e.thumbw = e.thumbhide >= pw ? 0 : e.thumbw;
            e.tabh = e.tabhide >= pw ? 0 : e.tabh;
            e.thumbh = e.thumbhide >= pw ? 0 : e.thumbh;
            for (var i in e.rl) nl[i] = e.rl[i] < window.RSIW ? 0 : e.rl[i];
            sl = nl[0];
            for (var i in nl)
              if (sl > nl[i] && nl[i] > 0) {
                sl = nl[i];
                ix = i;
              }
            var m =
              pw > e.gw[ix] + e.tabw + e.thumbw
                ? 1
                : (pw - (e.tabw + e.thumbw)) / e.gw[ix];
            newh = e.gh[ix] * m + (e.tabh + e.thumbh);
          }
          var el = document.getElementById(e.c);
          if (el !== null && el) el.style.height = newh + "px";
          el = document.getElementById(e.c + "_wrapper");
          if (el !== null && el) {
            el.style.height = newh + "px";
            el.style.display = "block";
          }
        } catch (e) {
          console.log("Failure at Presize of Slider:" + e);
        }
      }
    `}
			</script>
			{/* <style type="text/css" id="wp-custom-css">
				{`  input[type="submit"] {
        display: inline-block;
        padding: 11px 20px;
        margin-bottom: 15px;
        cursor: pointer;
        margin-right: 7px;
        margin-bottom: 15px;
        border: 0;
        border-radius: 5px;
        position: relative;
        overflow: hidden;
        box-shadow: inset 0 0 0 1px rgb(0 0 0 / 3%),
          inset 0px 4px 3px -2px rgb(0 0 0 / 7%);
      }
      .wpb_text_column :last-child input[type="submit"] {
        margin-bottom: 15px;
      }
      input[type="radio" i] {
        background-color: initial;
        cursor: default;
        appearance: auto;
        box-sizing: border-box;
        margin: 3px 3px 0px 5px;
        padding: initial;
        border: initial;
      }
      input[type="checkbox" i] {
        background-color: initial;
        cursor: default;
        appearance: auto;
        box-sizing: border-box;
        margin: 3px 3px 3px 4px;
        padding: initial;
        border: initial;
      }
      .sp-easy-accordion .sp-ea-single h3.ea-header a {
        font-size: 16px;
      } `}
			</style> */}
			{/* <style type="text/css" data-type="vc_shortcodes-default-css">
				{` .vc_do_icon {
        margin-bottom: 35px;
      }
        `}
			</style> */}
			{/* <style type="text/css" data-type="vc_shortcodes-custom-css">
				{` .vc_custom_1614376734080 {
        margin-top: 30px !important;
        margin-bottom: 30px !important;
        padding-top: 0px !important;
        padding-bottom: 0px !important;
      }
      .vc_custom_1614437933994 {
        margin-top: 0px !important;
        padding-top: 0px !important;
        padding-bottom: 0px !important;
      }
      .vc_custom_1614437999950 {
        padding-top: 3em !important;
        padding-bottom: 1em !important;
      } `}
			</style> */}
			{/* </Helmet> */}

			<a href="https://www.unitedanesthesia.com/#" id="start" title="Start"></a>
			<div className="nav-container" style={{ minHeight: '91px' }}>
				<div className="bar bar--sm visible-xs bg--dark bar--mobile-sticky pos-fixed" data-scroll-class="200px:pos-fixed" style={{}}>
					<div className="container">
						<div className="row">
							<div className="col-xs-8 col-sm-10">
								<a href="https://www.unitedanesthesia.com/" className="logo-holder">
									<img className="logo logo-dark" alt="United Anesthesia" src="/assets/united-anesthesia/scripts/ua-ghr-logo.png" width="250" />
									<img className="logo logo-light" alt="United Anesthesia" src="/assets/united-anesthesia/scripts/ua-ghr-logo.png" width="250" />
								</a>
							</div>
							<div className="col-xs-4 col-sm-2 text-right mobile-header">
								<a href="https://www.unitedanesthesia.com/#" className="hamburger-toggle" data-toggle-class="#menu1;hidden-xs">
									<i className="icon--sm stack-interface stack-menu"></i>
								</a>
							</div>
						</div>
					</div>
				</div>
				<nav id="menu1" className="bar bar--sm bar-1 hidden-xs hiddem-sm bg--dark pos-fixed" data-scroll-class="200px:pos-fixed">
					<div className="container">
						<div className="row">
							<div className="col-md-1 col-sm-2 hidden-xs">
								<div className="bar__module">
									<a href="https://www.unitedanesthesia.com/" className="logo-holder">
										<img className="logo logo-dark" alt="United Anesthesia" src="/assets/united-anesthesia/scripts/ua-ghr-logo.png" width="250" />
										<img className="logo logo-light" alt="United Anesthesia" src="/assets/united-anesthesia/scripts/ua-ghr-logo.png" width="250" />
									</a>
								</div>
							</div>
							<div className="col-md-11 col-sm-12 text-right text-left-xs text-left-sm">
								<div className="bar__module">
									<ul id="menu-mainnav" className="menu-horizontal text-left" ref={menuRef}>
										<li className="menu-item">
											<a href="https://www.unitedanesthesia.com/about-us">About</a>
										</li>
										<li
											className={`menu-item menu-item-has-children dropdown ${activeDropdown === 0 ? 'dropdown--active' : ''}`}
											onClick={() => handleDropdownClick(0)}
										>
											<span className="dropdown__trigger">Providers</span>
											<div className="dropdown__container" style={{ left: '-480.219px' }}>
												<div className="container">
													<div className="row">
														<div className="dropdown__content col-md-4 col-sm-4" style={{ left: '480.219px' }}>
															<ul className="menu-vertical">
																<li className="menu-item">
																	<a href="https://www.unitedanesthesia.com/anesthesia-providers">Anesthesia Providers</a>
																</li>
																<li className="menu-item">
																	<a href="https://www.unitedanesthesia.com/anesthesia-providers/anesthesiologist">Anesthesiologist</a>
																</li>
																<li className="menu-item">
																	<a href="https://www.unitedanesthesia.com/anesthesia-providers/certified-registered-nurse-anesthetist-crna">
																		CRNA – Certified Registered Nurse Anesthetist
																	</a>
																</li>
																<li className="menu-item">
																	<a href="https://www.unitedanesthesia.com/anesthesia-providers/provider-resources">Provider Resources</a>
																</li>
																<li className="menu-item">
																	<a href="https://www.unitedanesthesia.com/anesthesia-providers/faqs">Anesthesia Providers FAQs</a>
																</li>
																<li className="menu-item">
																	<a href="https://www.unitedanesthesia.com/anesthesia-providers/state-boards-of-medical-examiners">
																		State Boards of Medical Examiners
																	</a>
																</li>
																<li className="menu-item">
																	<a href="https://www.unitedanesthesia.com/anesthesia-providers/state-boards-of-nursing">State Boards of Nursing</a>
																</li>
																<li className="menu-item">
																	<a href="https://www.unitedanesthesia.com/anesthesia-providers/happy-birthday">Refer A Friend</a>
																</li>
															</ul>
														</div>
													</div>
												</div>
											</div>
										</li>
										<li
											className={`menu-item menu-item-has-children dropdown ${activeDropdown === 1 ? 'dropdown--active' : ''}`}
											onClick={() => handleDropdownClick(1)}
										>
											<span className="dropdown__trigger">Facility Solutions</span>
											<div className="dropdown__container" style={{ left: '-580.203px' }}>
												<div className="container">
													<div className="row">
														<div className="dropdown__content col-md-4 col-sm-4" style={{ left: '580.203px' }}>
															<ul className="menu-vertical">
																<li className="menu-item">
																	<a href="https://www.unitedanesthesia.com/facility-solutions">Facility Solutions for Anesthesia Coverage</a>
																</li>
																<li className="menu-item">
																	<a href="https://www.unitedanesthesia.com/facility-solutions/anesthesia-locum-tenens">Anesthesia Locum Tenens</a>
																</li>
																<li className="menu-item">
																	<a href="https://www.unitedanesthesia.com/facility-solutions/anesthesia-permanent-placement">
																		Anesthesia Permanent Placement
																	</a>
																</li>
																<li className="menu-item">
																	<a href="https://www.unitedanesthesia.com/facility-solutions/government-contracting-for-anesthesia">
																		Government Contracting for Anesthesia
																	</a>
																</li>
																<li className="menu-item">
																	<a href="https://www.unitedanesthesia.com/facility-solutions/anesthesia-coverage-faqs">
																		Facility Solutions for Anesthesia Coverage FAQs
																	</a>
																</li>
															</ul>
														</div>
													</div>
												</div>
											</div>
										</li>
										<li className="menu-item">
											<a href="https://www.unitedanesthesia.com/anesthesia-job-search" target="_blank">
												Job Search
											</a>
										</li>
										<li className="menu-item">
											<a href="https://www.unitedanesthesia.com/news">News</a>
										</li>
										<li className="menu-item">
											<a href="https://www.unitedanesthesia.com/contact">Contact Us</a>
										</li>
										<li className="menu-item">
											<a href="https://jobs.unitedanesthesia.com/signin" target="_blank">
												Sign In
											</a>
										</li>
										<li className="menu-item">
											<a href="https://jobs.unitedanesthesia.com/signup" target="_blank">
												Sign Up
											</a>
										</li>
									</ul>
								</div>
								<div className="bar__module stack-header-buttons"></div>
							</div>
						</div>
					</div>
				</nav>
			</div>

			<a className="back-to-top inner-link" title="Back to top" href="https://www.unitedanesthesia.com/#start" data-scroll-class="100vh:active">
				<i className="stack-interface stack-up-open-big"></i>
			</a>
			<script>
				{` window.RS_MODULES = window.RS_MODULES || {};
      window.RS_MODULES.modules = window.RS_MODULES.modules || {};
      window.RS_MODULES.waiting = window.RS_MODULES.waiting || [];
      window.RS_MODULES.defered = false;
      window.RS_MODULES.moduleWaiting = window.RS_MODULES.moduleWaiting || {};
      window.RS_MODULES.type = "compiled";
      `}
			</script>
			<script async="" src="/assets/united-anesthesia/scripts/js"></script>
			<script>
				{` window.dataLayer = window.dataLayer || [];
      function gtag() {
        dataLayer.push(arguments);
      }
      gtag("js", new Date());
      gtag("config", "G-WR961530FV");
      `}
			</script>
			<script type="text/html" id="wpb-modifications">
				{` window.wpbCustomElement = 1; `}
			</script>
			<link href="/assets/united-anesthesia/scripts/css(1)" rel="stylesheet" property="stylesheet" media="all" type="text/css" />
			<script>
				{` if (typeof revslider_showDoubleJqueryError === "undefined") {
        function revslider_showDoubleJqueryError(sliderID) {
          console.log(
            "You have some jquery.js library include that comes after the Slider Revolution files js inclusion."
          );
          console.log("To fix this, you can:");
          console.log(
            "1. Set 'Module General Options' -> 'Advanced' -> 'jQuery & OutPut Filters' -> 'Put JS to Body' to on"
          );
          console.log("2. Find the double jQuery.js inclusion and remove it");
          return "Double Included jQuery Library";
        }
      } `}
			</script>
			<link rel="stylesheet" href="/assets/united-anesthesia/scripts/animate.min.css" type="text/css" media="all" />
			<link rel="stylesheet" href="/assets/united-anesthesia/scripts/v4-shims.min.css" type="text/css" media="all" />
			<link rel="stylesheet" href="/assets/united-anesthesia/scripts/all.min.css" type="text/css" media="all" />
			<link rel="stylesheet" href="/assets/united-anesthesia/scripts/rs6.css" type="text/css" media="all" />
			<style id="rs-plugin-settings-inline-css" type="text/css">
				#rs-demo-id {}
			</style>
			<script type="text/javascript" src="/assets/united-anesthesia/scripts/hooks.min.js"></script>
			<script type="text/javascript" src="/assets/united-anesthesia/scripts/i18n.min.js"></script>
			<script type="text/javascript" id="wp-i18n-js-after">
				{`wp.i18n.setLocaleData({ "text direction\u0004ltr": ["ltr"] });`}
			</script>
			<script type="text/javascript" src="/assets/united-anesthesia/scripts/parallax.js"></script>
			<script type="text/javascript" src="/assets/united-anesthesia/scripts/isotope.js"></script>
			<script type="text/javascript" src="/assets/united-anesthesia/scripts/final-countdown.js"></script>
			<script type="text/javascript" src="/assets/united-anesthesia/scripts/flickity.js"></script>
			<script type="text/javascript" src="/assets/united-anesthesia/scripts/granim.js"></script>
			<script type="text/javascript" src="/assets/united-anesthesia/scripts/smooth-scroll.js"></script>
			<script type="text/javascript" src="/assets/united-anesthesia/scripts/spectragram.js"></script>
			<script type="text/javascript" src="/assets/united-anesthesia/scripts/twitter-post-fetcher.js"></script>
			<script type="text/javascript" src="/assets/united-anesthesia/scripts/ytplayer.js"></script>
			<script type="text/javascript" src="/assets/united-anesthesia/scripts/easy-pie-chart.js"></script>
			<script type="text/javascript" src="/assets/united-anesthesia/scripts/steps.js"></script>
			<script type="text/javascript" src="/assets/united-anesthesia/scripts/lightbox.js"></script>
			<script type="text/javascript" id="ebor-scripts-wp-js-extra">
				{`    var stack_data = {
        access_token: "replaceWithYourOwn",
        client_id: "replaceWithYourOwn",
        typed_speed: "100",
        map_marker: "\/images\/mapmarker.png",
        map_marker_title: "Stack",
        lightbox_text: "Image %1 of %2",
      };`}
			</script>
			<script type="text/javascript" src="/assets/united-anesthesia/scripts/scripts_wp.js" id="ebor-scripts-wp-js"></script>
			<script type="text/javascript" src="/assets/united-anesthesia/scripts/scripts.js" id="ebor-scripts-js"></script>
			<script type="text/javascript" src="/assets/united-anesthesia/scripts/js_composer_front.min.js" id="wpb_composer_front_js-js"></script>
			<script type="text/javascript" src="/assets/united-anesthesia/scripts/vc-waypoints.min.js" id="vc_waypoints-js"></script>
			<script></script>
			<script id="rs-initialisation-scripts">
				{`  var tpj = jQuery;
      var revapi1;
      if (window.RS_MODULES === undefined) window.RS_MODULES = {};
      if (RS_MODULES.modules === undefined) RS_MODULES.modules = {};
      RS_MODULES.modules["revslider11"] = {
        once:
          RS_MODULES.modules["revslider11"] !== undefined
            ? RS_MODULES.modules["revslider11"].once
            : undefined,
        init: function () {
          window.revapi1 =
            window.revapi1 === undefined ||
            window.revapi1 === null ||
            window.revapi1.length === 0
              ? document.getElementById("rev_slider_1_1")
              : window.revapi1;
          if (
            window.revapi1 === null ||
            window.revapi1 === undefined ||
            window.revapi1.length == 0
          ) {
            window.revapi1initTry =
              window.revapi1initTry === undefined
                ? 0
                : window.revapi1initTry + 1;
            if (window.revapi1initTry < 20)
              requestAnimationFrame(function () {
                RS_MODULES.modules["revslider11"].init();
              });
            return;
          }
          window.revapi1 = jQuery(window.revapi1);
          if (window.revapi1.revolution == undefined) {
            revslider_showDoubleJqueryError("rev_slider_1_1");
            return;
          }
          revapi1.revolutionInit({
            revapi: "revapi1",
            DPR: "dpr",
            visibilityLevels: "1240,1024,778,480",
            gridwidth: 1122,
            gridheight: 520,
            lazyType: "smart",
            perspective: 600,
            perspectiveType: "local",
            editorheight: "520,768,960,720",
            responsiveLevels: "1240,1024,778,480",
            progressBar: { disableProgressBar: true },
            navigation: {
              onHoverStop: false,
            },
            viewPort: {
              global: true,
              globalDist: "-200px",
              enable: false,
              visible_area: "20%",
            },
            fallbacks: {
              allowHTML5AutoPlayOnAndroid: true,
            },
          });
        },
      };
      if (window.RS_MODULES.checkMinimal !== undefined) {
        window.RS_MODULES.checkMinimal();
      } `}
			</script>

			<div id="lightboxOverlay" className="lightboxOverlay" style={{ display: 'none' }}></div>
			<div id="lightbox" className="lightbox" style={{ display: 'none' }}>
				<div className="lb-outerContainer">
					<div className="lb-container">
						<img className="lb-image" src="data:image/gif;base64,R0lGODlhAQABAIAAAP///wAAACH5BAEAAAAALAAAAAABAAEAAAICRAEAOw==" />
						<div className="lb-nav">
							<a className="lb-prev" href="https://www.unitedanesthesia.com/"></a>
							<a className="lb-next" href="https://www.unitedanesthesia.com/"></a>
						</div>
						<div className="lb-loader">
							<a className="lb-cancel"></a>
						</div>
					</div>
				</div>
				<div className="lb-dataContainer">
					<div className="lb-data">
						<div className="lb-details">
							<span className="lb-caption"></span>
							<span className="lb-number"></span>
						</div>
						<div className="lb-closeContainer">
							<a className="lb-close"></a>
						</div>
					</div>
				</div>
			</div>
			<div className="container containerMeasure" style={{ opacity: 0, pointerEvents: 'none' }}></div>

			<style>
				{` @font-face {
        font-family: FigtreeVF;
        src: url(chrome-extension://majdfhpaihoncoakbjgbdhglocklcgno/fonts/FigtreeVF.woff2)
            format("woff2 supports variations"),
          url(chrome-extension://majdfhpaihoncoakbjgbdhglocklcgno/fonts/FigtreeVF.woff2)
            format("woff2-variations");
        font-weight: 100 1000;
        font-display: swap;
      } `}
			</style>
			<div id="veepn-breach-alert">
				<template shadowrootmode="open">
					<style>
						{`  .breach-popup {
            font-family: FigtreeVF, sans-serif;
            position: fixed;
            z-index: 2147483638;
            text-rendering: optimizelegibility;
            top: 0;
            left: 0;
            right: 0;
            pointerEvents: none;
            padding-inline: 16px;
            height: 0;
            overflow: visible;
            color: #222e3a;
          }
          .breach-popup * {
            box-sizing: border-box;
          }
          .breach-popup__inner {
            background-color: #de4558;
            width: 100%;
            border-radius: 16px;
            margin-inline: auto;
            pointerEvents: all;
            position: relative;
            transition: transform 0.25s ease-in-out, max-width 0.25s ease-in-out;
            transform: translateY(16px);
            max-height: calc(100svh - 80px);
            display: flex;
            flex-direction: column;
          }
          .breach-popup__header {
            min-height: 32px;
            display: flex;
            align-items: center;
            justify-content: space-between;
            column-gap: 16px;
            padding: 4px;
            cursor: pointer;
          }
          .breach-popup__close {
            cursor: pointer;
            background-color: transparent;
            border-style: none;
            outline: none;
            display: flex;
            align-items: center;
            justify-content: center;
            width: 24px;
            height: 24px;
            flex-shrink: 0;
            opacity: 0.5;
          }
          .breach-popup__wrap {
            display: grid;
            grid-template-rows: 0fr;
            transition: grid-template-rows 0.25s ease-in-out;
            overflow: hidden;
          }
          .breach-popup__content {
            overflow: hidden;
            opacity: 0;
            transform: translateY(-10px);
          }
          .breach-popup--minimize .breach-popup__inner {
            max-width: 485px;
            transform: translateY(-100%);
          }
          .breach-popup--collapse .breach-popup__inner {
            max-width: 485px;
          }
          .breach-popup--expand .breach-popup__inner {
            max-width: 1120px;
          }
          .breach-popup--expand .breach-popup__wrap {
            grid-template-rows: 1fr;
          }
          .breach-popup--expand .breach-popup__content {
            opacity: 1;
            transform: translateY(0);
            transition: transform 0.25s ease-in-out, opacity 0.25s ease-in-out;
            transition-delay: 0.15s;
          }
          .breach-popup--expand .breach-popup__header {
            cursor: default;
          }
          .breach-info {
            padding: 2px;
            height: 100%;
          }
          .breach-info__inner {
            padding: 22px 22px 0;
            background-color: #fff;
            border-bottom-left-radius: 15px;
            border-bottom-right-radius: 15px;
            height: 100%;
            overflow: auto;
          }
          .breach-info__alert {
            font-size: 24px;
            line-height: 32px;
            font-weight: 700;
            margin: 0;
          }
          .breach-info__list {
            margin-top: 24px;
            display: flex;
            flex-wrap: wrap;
            gap: 24px;
          }
          @media only screen and (width >= 992px) {
            .breach-info__list {
              flex-wrap: nowrap;
            }
          }
          .breach-info__item {
            width: 100%;
          }
          .breach-info__item:nth-child(2) {
            max-width: 320px;
          }
          .breach-info__item:nth-child(3) {
            max-width: 200px;
          }
          .breach-info__title {
            font-size: 18px;
            font-weight: 700;
            line-height: 32px;
            letter-spacing: -0.1px;
            color: #de4558;
            margin-top: 0;
            margin-bottom: 4px;
          }
          .breach-info__description {
            font-size: 16px;
            line-height: 28px;
            letter-spacing: -0.1px;
          }
          .breach-info__description ul {
            margin: 0;
          }
          .breach-info__actions {
            display: flex;
            justify-content: center;
            padding-top: 32px;
            padding-bottom: 22px;
            background-color: #fff;
            position: sticky;
            bottom: 0;
          }
          .breach-info__btn {
            cursor: pointer;
            border-style: none;
            outline: none;
            display: inline-flex;
            align-items: center;
            height: 48px;
            padding-inline: 20px;
            border-radius: 12px;
            text-align: center;
            font-size: 16px;
            font-weight: 700;
            line-height: 28px;
            letter-spacing: -0.1px;
            color: #fff;
            background-color: #ff6400;
          }
          .button-expand {
            position: absolute;
            bottom: 0;
            left: 50%;
            transform: translate(-50%, 100%);
            z-index: 1;
          }
          .button-expand__pointer {
            cursor: pointer;
          }
          .button-expand__alert {
            pointerEvents: none;
            transition: opacity 0.25s ease-in-out;
          }
          .button-expand__arrow {
            pointerEvents: none;
            transition: transform 0.25s ease-in-out, opacity 0.25s ease-in-out;
            transform-origin: center;
          }
          .button-expand--minimize .button-expand__arrow,
          .button-expand--collapse .button-expand__alert,
          .button-expand--expand .button-expand__alert {
            opacity: 0;
          }
          .button-expand--expand .button-expand__arrow {
            transform: rotate(180deg);
          }
          .header-collapse {
            display: flex;
            align-items: center;
            flex-wrap: wrap;
            column-gap: 4px;
            padding-left: 8px;
            font-size: 14px;
            line-height: 20px;
            letter-spacing: -0.1px;
            color: #fff;
          }
          .header-expand {
            display: flex;
            align-items: center;
            flex-wrap: wrap;
            column-gap: 4px;
            padding-left: 20px;
            font-size: 14px;
            font-weight: 500;
            line-height: 20px;
            letter-spacing: -0.1px;
            color: #fff;
          } `}
					</style>
				</template>
			</div>
			<style>
				{`  @font-face {
        font-family: FigtreeVF;
        src: url(chrome-extension://majdfhpaihoncoakbjgbdhglocklcgno/fonts/FigtreeVF.woff2)
            format("woff2 supports variations"),
          url(chrome-extension://majdfhpaihoncoakbjgbdhglocklcgno/fonts/FigtreeVF.woff2)
            format("woff2-variations");
        font-weight: 100 1000;
        font-display: swap;
      } `}
			</style>
		</>
	)
}
